import { useCallback, useEffect, useRef, useState } from 'react';
import { mailError } from '../mailboxModel';
import { acknowledgeNotification, fetchNotifications } from '../models/mailApi';

export function useMailNotifications({ enabled, profile, socket, live, refresh, pathname, onArrival, destroy, notify }) {
  const [notifications, setNotifications] = useState([]);
  const seen = useRef(new Set());
  const acknowledged = useRef(new Set());
  const notificationAccess = useRef(enabled);
  notificationAccess.current = enabled;
  useEffect(() => () => {
    live.current = false;
    seen.current.forEach(id => destroy(`mail-${id}`));
  }, [destroy, live]);
  useEffect(() => {
    if (!enabled) seen.current.forEach(id => destroy(`mail-${id}`));
  }, [enabled, destroy]);
  const acknowledge = useCallback(async id => {
    if (!live.current || !notificationAccess.current || acknowledged.current.has(id)) return;
    acknowledged.current.add(id);
    try { await acknowledgeNotification(id); if (live.current) setNotifications(rows => rows.filter(row => row.id !== id)); }
    catch (failure) { acknowledged.current.delete(id); if (live.current) notify.error(mailError(failure)); }
  }, [notify, live]);
  useEffect(() => {
    if (!enabled || !profile) return undefined;
    let active = true;
    const load = () => fetchNotifications().then(rows => { if (active) setNotifications(rows); }).catch(() => {});
    load();
    const arrival = payload => {
      const row = payload?.data;
      if (!row?.id || seen.current.has(row.id)) return;
      seen.current.add(row.id); refresh(); load();
      if (pathname === `/mail/${row.gmail_thread_id}`) return;
      onArrival(row, acknowledge);
    };
    socket?.on('mailbox:new_message', arrival);
    const updated = payload => {
      const row = payload?.data;
      if (row?.acknowledged_at) { acknowledged.current.add(row.id); destroy(`mail-${row.id}`); }
      load();
    };
    socket?.on('mailbox:notification_updated', updated);
    socket?.on('connect', load);
    return () => { active = false; socket?.off('mailbox:new_message', arrival); socket?.off('mailbox:notification_updated', updated); socket?.off('connect', load); };
  }, [enabled, profile, socket, refresh, pathname, onArrival, destroy, acknowledge]);
  return { notifications, acknowledge };
}
